module.exports = __webpack_public_path__ + "img/柚子11.99546bb5.png";